import { ReactElement } from 'react';

import { IconsPropsI } from './interfaces';

const SolidPersonIcon = ({
  width = 14,
  height = 14,
  fill = '#1F61F7',
  alternativeFill = 'white',
}: IconsPropsI): ReactElement => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99992 0.333008C3.31992 0.333008 0.333252 3.31967 0.333252 6.99967C0.333252 10.6797 3.31992 13.6663 6.99992 13.6663C10.6799 13.6663 13.6666 10.6797 13.6666 6.99967C13.6666 3.31967 10.6799 0.333008 6.99992 0.333008ZM6.33325 11.6663V10.333H7.66659V11.6663H6.33325ZM8.44658 7.11301L9.04659 6.49967C9.72658 5.81967 9.95992 4.65301 9.17325 3.56634C8.57325 2.73301 7.60659 2.20634 6.59325 2.36634C5.55992 2.52634 4.72658 3.27301 4.43992 4.25301C4.33325 4.62634 4.59992 4.99967 4.98659 4.99967H5.18658C5.44659 4.99967 5.65325 4.81301 5.73325 4.56634C5.95325 3.93301 6.63992 3.51301 7.37992 3.71967C7.84658 3.85301 8.21992 4.25967 8.30658 4.73967C8.39325 5.20634 8.24658 5.64634 7.93992 5.93967L7.11325 6.77968C6.83325 7.05967 6.61325 7.40634 6.47992 7.79301C6.38659 8.06634 6.33325 8.35967 6.33325 8.66634V8.99967H7.66658C7.66658 8.69301 7.69992 8.45301 7.75325 8.23968C7.87325 7.75968 8.11325 7.45301 8.44658 7.11301Z"
        fill={fill}
      />
    </svg>
  );
};

export default SolidPersonIcon;
